import * as apiValues from '../constants/apiValues';
import * as helpers from '../helpers';
import * as mHeaderActions from '../actions/mHeaderActions';
import * as navigationLinkActions from '../actions/navigationLinkActions';
import PropTypes from 'prop-types';
import React from 'react';
import SuperLink, {resolveSuperLinkHref} from './SuperLink';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from '../withRouterCompat';


/** External http(s) nav destinations (and CMS opensInNewTab) open in a new tab. */
export function navigationLinkTarget(navigationLink, linkUrl) {
  if (navigationLink?.opensInNewTab) return '_blank';
  const resolved = resolveSuperLinkHref(linkUrl);
  if (resolved?.kind === 'native' && /^https?:/i.test(resolved.href)) {
    return '_blank';
  }
  return undefined;
}


class NavigationLink extends React.Component{
  componentDidMount(){
    if(this.props.navigationLink && this.props.navigationLink.title){
      // passed in
    }
    else if(this.props.cmsId){
      this.props.actions.navigationLink.initNavigationLink(this.props.cmsId);
    }
  }


  renderDescription(){
    if(!this.props.navigationLink.description) return null;

    return (
      <div className="navigationlink__description">{helpers.nToP(this.props.navigationLink.description)}</div>
    );
  }
  renderImage(){
    if(!this.props.navigationLink.imageOptional) return null;

    const title = this.props.navigationLink.title;
    return (
      <img alt={title ? '' : undefined} className=""
           src={apiValues.imgPath(this.props.navigationLink.imageOptional.url)}/>
    );
  }
  renderTitle(){
    if(!this.props.navigationLink.title) return null;

    return (
      <div className="navigationlink__title">
        {helpers.getHighlightedText(this.props.navigationLink.title, this.props.highlight)}
      </div>
    );
  }
  render(){
    if(!this.props.navigationLink ||
       (!this.props.navigationLink.description && !this.props.navigationLink.imageOptional && !this.props.navigationLink.title)) return null;

    let baseClass = `navigationlink ${this.props.className || ''}`;
    let typeClass = this.props.navigationLink.type ? ` navigationlink--${this.props.navigationLink.type}` : '';
    let isSelectedClass = this.props.navigationLink.isSelected ? ` navigationlink--is-selected` : '';
    let className = `${baseClass} ${typeClass} ${isSelectedClass}`;
    let linkUrl = this.props.navigationLink.document ? `${apiValues.getCmsPath()}${this.props.navigationLink.document.url}` : this.props.navigationLink.url ? this.props.navigationLink.url : undefined;
    const Wrapper = this.props.asListItem ? 'li' : 'div';

    if(linkUrl){
      const linkLabel = this.props.navigationLink.title || undefined;
      return (
        <Wrapper className={className}>
          <SuperLink to={linkUrl}
                     className='navigationlink__link'
                     target={navigationLinkTarget(this.props.navigationLink, linkUrl)}
                     onClick={this.props.onClick}
                     aria-label={linkLabel}>
            {this.renderImage()}
            {this.renderTitle()}
          </SuperLink>
          {this.renderDescription()}
        </Wrapper>
      );
    }

    return (
      <Wrapper className={className}>
        <button type="button"
                className="navigationlink__link navigationlink__link--action"
                onClick={this.props.onClick}>
          {this.renderImage()}
          {this.renderTitle()}
        </button>
        {this.renderDescription()}
      </Wrapper>
    );
  }
}


export default withRouter(connect(
  (state, ownProps) => (
    ownProps.cmsId ? {navigationLink: helpers.getById(state.navigationLink, ownProps.cmsId)} : {}
  ),
  (dispatch) => ({
    actions: {
      navigationLink: bindActionCreators(navigationLinkActions, dispatch),
      mHeaderActions: bindActionCreators(mHeaderActions, dispatch),
    },
  }),
)(NavigationLink));


NavigationLink.propTypes = {
  actions: PropTypes.object,
  asListItem: PropTypes.bool,
  className: PropTypes.string,
  cmsId: PropTypes.string,
  highlight: PropTypes.string,
  navigationLink: PropTypes.object,
  onClick: PropTypes.func,
};
